import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { URLSearchParamsConstructor } from "../../../helpers/UrlSearchParamConstructor";
import { sec } from "../../../security";
import { DealResponse } from "./types";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const apiDealsV2Slice = createApi({
  reducerPath: "dealsV2",
  tagTypes: ["getDealsByEmployerId", "getDealByAttorneyId"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),

  endpoints: (builder) => ({
    getDealsByEmployerId: builder.query<DealResponse, any>({
      query: (employerId) =>
        `/api/v2/deals/employers_list?${
          employerId ? `employerId=${employerId}` : ""
        }`,
      providesTags: ["getDealsByEmployerId"]
    }),
    getDealByAttorneyId: builder.query<DealResponse, any>({
      query: (args) => {
        const params = URLSearchParamsConstructor(args);
        return {
          url: "/api/v2/deals/attorney_list",
          method: "get",
          params
        };
      },
      providesTags: ["getDealByAttorneyId"]
    })
  })
});

export const { useGetDealByAttorneyIdQuery, useGetDealsByEmployerIdQuery } =
  apiDealsV2Slice;
